require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-why-is-bic-opposing-an-idb-loan-to-brazilian-beef-exporter.json") })
        }
      }, "path---en-us-update-why-is-bic-opposing-an-idb-loan-to-brazilian-beef-exporter");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-why-is-bic-opposing-an-idb-loan-to-brazilian-beef-exporter!./.cache/json/en-us-update-why-is-bic-opposing-an-idb-loan-to-brazilian-beef-exporter.json
// module id = 864
// module chunks = 231608221292675